// extracted by mini-css-extract-plugin
export default {"item":"DropdownItem_item__Ilm38","icon":"DropdownItem_icon__bfBrC"};